import { render, staticRenderFns } from "./UnlockBossModal.vue?vue&type=template&id=367dc31f&scoped=true&"
import script from "./UnlockBossModal.vue?vue&type=script&lang=js&"
export * from "./UnlockBossModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367dc31f",
  null
  
)

export default component.exports